module.exports = __webpack_public_path__ + "static/media/myZoneTicketingWhite.682665f2.svg";